export default {
  strict: true,
  namespaced: true,
  state: {
    brandId: '',
    serviceArea: {
      activeId: 0,
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 15,
      orderAsc: 1,
      search: '',
      isLoading: false,
      discountStart: '',
      discountEnd: '',
      discountWidget: false,
      discountAdmin: false,
      discountApp: false,
      discountCSR: false,
      holidayDate: '',
      holidayDate2: '',
      holidayDate3: '',
      holidayDate4: '',
      holidayDate5: '',
      holidayDate6: '',
      holidayDate7: '',
      holidayDate8: '',
      holidayDate9: '',
      holidayDate10: '',
      asapDiscountStart: '',
      asapDiscountEnd: '',
      asapDiscountWidget: false,
      asapDiscountAdmin: false,
      asapDiscountApp: false,
      asapDiscountCSR: false,
      asapHolidayDate: '',
      asapHolidayDate2: '',
      asapHolidayDate3: '',
      asapHolidayDate4: '',
      asapHolidayDate5: '',
      asapHolidayDate6: '',
      asapHolidayDate7: '',
      asapHolidayDate8: '',
      asapHolidayDate9: '',
      asapHolidayDate10: '',
      charterDiscountStart: '',
      charterDiscountEnd: '',
      charterHolidayDate: '',
      charterHolidayDate2: '',
      charterHolidayDate3: '',
      charterHolidayDate4: '',
      charterHolidayDate5: '',
      charterHolidayDate6: '',
      charterHolidayDate7: '',
      charterHolidayDate8: '',
      charterHolidayDate9: '',
      charterHolidayDate10: '',
    }
  },
  mutations: {
    setBrandId (state, value) { state.brandId = value },
    // resetServiceAreas (state) { state.serviceArea.list = [] },
    setServiceAreaActiveId (state, value) { state.serviceArea.activeId = value },
    clearServiceAreaList (state) { state.serviceArea.list = [] },
    setServiceAreaList (state, value) { state.serviceArea.list = value },
    setServiceAreaMaxList (state, value) { state.serviceArea.maxList = value },
    setServiceAreaCurrentPage (state, value) { state.serviceArea.currentPage = value },
    setServiceAreaPerPage (state, value) { state.serviceArea.perPage = value },
    setServiceAreaOrderAsc (state, value) { state.serviceArea.orderAsc = value },
    setServiceAreaSearch (state, value) { state.serviceArea.search = value },
    setServiceAreaIsLoading (state, value) { state.serviceArea.isLoading = value },
    setDiscountStart (state, value) { state.serviceArea.discountStart = value },
    setDiscountEnd (state, value) { state.serviceArea.discountEnd = value },
    setHolidayDate (state, value) { state.serviceArea.holidayDate = value },
    setAsapDiscountStart (state, value) { state.serviceArea.asapDiscountStart = value },
    setAsapDiscountEnd (state, value) { state.serviceArea.asapDiscountEnd = value },
    setAsapHolidayDate (state, value) { state.serviceArea.asapHolidayDate = value },
    setServiceAreaCharterData (state, data) {
      for (let field in data) {
        state.serviceArea[field] = data[field]
      }
    },
    setHolidayData (state, data) {
      let holiday = data.type === 'asap' ? 'asapHolidayDate' : 'holidayDate'
      if (data.index === 1) {
        state.serviceArea[`${holiday}`] = data.value
      } else {
        state.serviceArea[`${holiday}${data.index}`] = data.value
      }
    },
    setCharterHolidayData (state, data) {
      if (data.index === 1) {
        state.serviceArea.charterHolidayDate = data.value
      } else {
        state.serviceArea[`charterHolidayDate${data.index}`] = data.value
      }
    },
    setDcType (state, data) {
      state.serviceArea[data.field] = data.value
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/pricing/service-area.js